import React from 'react';
import { EventTypeProcess } from '../../../types/ViewModel/EventTypeProcess';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledButton } from './ToolboxButton.styles';
import { EventTypeProcessInstance } from '../../../types/ViewModel/EventTypeProcessInstance';
import { useEventStore } from '../../../context/EventContext';

type Props = {
    onChange: (prc: EventTypeProcess, prcInst: EventTypeProcessInstance | null) => void;
    evTypeProcess: EventTypeProcess;
    prcInst: EventTypeProcessInstance | null;
    prcKey: string;
    level: number;
};

const ToolboxButtonComponent: React.FC<Props> = (props) => {
    const { setSelectedEvent } = useEventStore();

    const handleAction = (prc: EventTypeProcess, prcInst: EventTypeProcessInstance | null) => () => {
        setSelectedEvent(null);
        props.onChange(prc, prcInst);
    };

    const getEventTypeNameForSarExercise = () => {
        return (
            <span>
                Nav. - Start Casualty & SAR <b>(Drill / Exercise)</b>
            </span>
        );
    };

    const getEventTypeName = (prc: EventTypeProcess) => {
        if (prc.evTypePrcList && prc.evTypePrcList.length > 0) {
            return prc.eventTypeGroup.name;
        } else {
            // Use displayNameToolbox which respects date-based name overrides (e.g., SOSP -> BOSP)
            return prc.eventType.eventTypeId === 206 ? getEventTypeNameForSarExercise() : prc.eventType?.displayNameToolbox ?? prc.eventType?.name;
        }
    };

    const getInstanceDescription = (inst: EventTypeProcessInstance): string => {
        return inst.instanceDescription;
    };

    const getEventTypeKey = (prc: EventTypeProcess): string => {
        return props.prcKey + '-' + props.level.toString() + '-' + prc.eventType?.eventTypeId.toString();
    };

    const getInstanceKey = (prc: EventTypeProcess, inst: EventTypeProcessInstance): string => {
        return props.prcKey + '-' + props.level.toString() + '-' + prc.eventType?.eventTypeId.toString() + '-' + inst.sequenceNr?.toString();
    };

    const getButtonName = (prc: EventTypeProcess, inst: EventTypeProcessInstance | null): string | React.ReactNode => {
        if (inst) {
            return getInstanceDescription(inst);
        }
        return getEventTypeName(prc);
    };

    const getKey = (prc: EventTypeProcess, inst: EventTypeProcessInstance | null): string => {
        if (inst) {
            return getInstanceKey(prc, inst);
        }
        return getEventTypeKey(prc);
    };

    const isBtnSelected = (): boolean => {
        if (props.prcInst) {
            return props.prcInst.isSelected;
        }
        return props.evTypeProcess.isSelected;
    };

    const showDownArrow = (): boolean => {
        if (props.prcInst) {
            return props.prcInst.isExpanded;
        }
        return props.evTypeProcess.isExpanded;
    };

    const showArrow = (): boolean => {
        return props.evTypeProcess.isExpandable;
    };

    const isEventTypeMandatory = (): boolean => {
        return !!(
            props.prcInst ||
            (props.evTypeProcess.evTypePrcInstanceList && props.evTypeProcess.evTypePrcInstanceList.length > 0) ||
            props.evTypeProcess.isMandatory
        );
        // return !!(
        //     props.evTypeProcess.eventType!.mandatory &&
        //     (props.prcInst ||
        //         (props.evTypeProcess.evTypePrcInstanceList && props.evTypeProcess.evTypePrcInstanceList.length > 0) ||
        //         props.evTypeProcess.isMandatory)
        // );
    };

    return (
        <>
            <StyledButton
                className="list-item"
                isSelected={isBtnSelected()}
                notShowArrow={!showArrow()}
                key={getKey(props.evTypeProcess, props.prcInst)}
                onClick={handleAction(props.evTypeProcess, props.prcInst)}
            >
                {showArrow() && <FontAwesomeIcon className={`right-arrow-icon ${showDownArrow() ? 'down-arrow-icon' : ''}`} icon="chevron-right" />}
                <span className="event-icon" dangerouslySetInnerHTML={{ __html: props.evTypeProcess.eventType?.icon }} />
                <span className="event-text">{getButtonName(props.evTypeProcess, props.prcInst)}</span>
                {isEventTypeMandatory() && (
                    <span
                        className={`edit-icon edited-rotation-item`}
                        dangerouslySetInnerHTML={{
                            __html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%"> <circle cx="50" cy="50" r="50" stroke-width="1" fill="OrangeRed"/> <path d="M0,44.439791L18.98951,54.569246 0.47998798,62.66881z M17.428029,12.359973L36.955557,23.568769 21.957478,49.686174 20.847757,46.346189 15.11851,45.756407 14.138656,42.166935 8.5292659,41.966761 6.9493899,38.037481 2.4399572,38.477377z M26.812517,0.0009765625C27.350616,-0.012230873,27.875986,0.10826397,28.348372,0.3782568L42.175028,8.3180408C43.85462,9.2780154,44.234529,11.777948,43.02482,13.89789L41.375219,16.767812 21.460039,5.3381228 23.10964,2.4582005C23.979116,0.941679,25.437378,0.034730911,26.812517,0.0009765625z" fill="white" transform="translate(30 20)"/></svg>',
                        }}
                    />
                )}
            </StyledButton>
        </>
    );
};

export default ToolboxButtonComponent;
